<!--
무자료 등록(재고방식) > 라벨출력 안내 > 보관장소 랜덤작성
-->
<template>
    <!-- 폼 화면 -->
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <div class="uk-text-large3 uk-text-center">
                    보관장소 랜덤작성
                </div>
                <div class="uk-text-large uk-text-center">
                    * fixed 부분을 제외한 나머지 숫자5자리를 랜덤하게 생성합니다.<br />
                    (중복되지 않는 고유한 보관장소 발행)
                </div>
            </div>

            <div class="uk-modal-body uk-flex uk-flex-center">

                <div class="uk-width-small uk-margin-right">
                    <span class="uk-text-large uk-text-muted">fixed</span>
                    <div>
                        <app-input-text
                            v-model="inputFixed"
                            placeholder="e.g. OS1"
                            input-size="large"
                            text-style="font-size: 2rem; text-align: center;"
                        ></app-input-text>
                    </div>
                </div>

                <div class="">
                    <span class="uk-text-large uk-text-muted">random sample</span>
                    <div class="random-sample">
                        - 00000
                    </div>
                </div>


            </div>



            <div class="uk-modal-footer uk-text-center">

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-button-large uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-primary uk-button-large"
                    @click="submit"
                >
                    <span uk-icon="icon: check"></span>
                    완료(랜덤생성)
                </button>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,

            // 지역ID
            regionId: Number,

            /**
             * (object) 박스정보
             * {
             *     tracking_no,
             *     user_id,
             *     name_prefix,
             * }
             */
            box: {
                type: Object,
            },

            /**
             * 등록된 상품정보 배열
             */
            prods: {
                type: Array,
            },
        },
        data: function () {
            return {
                // 입력 - 고정된 보관장소
                inputFixed: null,
            };
        },
        computed: {
            /**
             * 상품ID 배열
             * @return array [id, id ...]
             */
            prodIds() {
                return _.map(this.prods, 'id');
            },
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {

                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             */
            form() {
                this.displayForm();
            },

            /**
             * submit
             */
            submit() {
                // 입력검증
                if (! this.inputFixed) {
                    alert('보관장소(fixed) 를 입력하세요');
                    return;
                }

                // promise 생성
                let p = new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/regions/' + this.regionId + '/nodata-stocks/random-storage',
                        data: {
                            '_token': this.csrfToken,
                            'prod_ids': JSON.stringify(this.prodIds),

                            fixed:  this.inputFixed,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                p.then((response) => {
                    this.box.storage = response.storage;
                    _.each(this.prods, (prod) => {
                        prod.storage = response.storage;
                    });

                    UIkit.modal(this.$el).hide();
                }).catch(() => {
                    // 오류인경우
                });
            },


        },


    }
</script>



<style lang="scss" scoped>
    .random-sample {
        font-size: 2.5rem;
        color: #999;
        text-align: left;
    }

</style>